const L = require('leaflet');

export const myIcon = L.icon({
    iconUrl: '/assets/images/customMarker.png',
    iconSize: [25, 25],
    // iconAnchor: [0, 0],
});

export const projectIcon = L.icon({
    iconUrl: '/assets/images/projectMarker.png',
    iconSize: [33, 35],
    // iconAnchor: [17, 33],
});

export const ggsIcon = L.icon({
    // iconUrl: '/assets/images/customMarker_black.png',
    iconUrl: '/assets/images/triangle.svg',
    iconSize: [30, 30],
    // iconAnchor: [0, 0],
});

export const wgsIcon = L.icon({
    // iconUrl: '/assets/images/customMarker_blue.png',
    iconUrl: '/assets/images/square.svg',
    iconSize: [30, 30],
    // iconAnchor: [0, 0],
});

export const myIcon3 = L.icon({
    // iconUrl: '/assets/images/customMarker_red.png',
    iconUrl: '/assets/images/pipeline.svg',
    iconSize: [20, 70],
    // iconAnchor: [0, 0],
});

export const well = L.icon({
    // iconUrl: '/assets/images/customMarker_red.png',
    iconUrl: '/assets/images/well.png',
    iconSize: [25, 25],
    // iconAnchor: [0, 0],
});

export const well_land = L.icon({
    // iconUrl: '/assets/images/customMarker_red.png',
    iconUrl: '/assets/images/well_land.png',
    iconSize: [25, 25],
    // iconAnchor: [0, 0],
});

export const well_drilling = L.icon({
    // iconUrl: '/assets/images/customMarker_red.png',
    iconUrl: '/assets/images/well_drilling.png',
    iconSize: [25, 25],
    // iconAnchor: [0, 0],
});

export const well_completion = L.icon({
    // iconUrl: '/assets/images/customMarker_red.png',
    iconUrl: '/assets/images/well_completion.png',
    iconSize: [25, 25],
    // iconAnchor: [0, 0],
});

export const well_workover = L.icon({
    // iconUrl: '/assets/images/customMarker_red.png',
    iconUrl: '/assets/images/well_workover.png',
    iconSize: [25, 25],
    // iconAnchor: [0, 0],
});

export const well_production_conventional = L.icon({
    // iconUrl: '/assets/images/customMarker_red.png',
    iconUrl: '/assets/images/well_production_conventional.png',
    iconSize: [25, 25],
    // iconAnchor: [0, 0],
});

export const well_production_unconvention = L.icon({
    // iconUrl: '/assets/images/customMarker_red.png',
    iconUrl: '/assets/images/well_production_unconvention.png',
    iconSize: [25, 25],
    // iconAnchor: [0, 0],
});


export const amber_circle = L.icon({
    // iconUrl: '/assets/images/customMarker_red.png',
    iconUrl: '/assets/images/amber_circle.png',
    iconSize: [25, 25],
    // iconAnchor: [0, 0],
});

export const amber_triangle = L.icon({
    // iconUrl: '/assets/images/customMarker_red.png',
    iconUrl: '/assets/images/amber_triangle.png',
    iconSize: [25, 25],
    // iconAnchor: [0, 0],
});

export const dark_green_square = L.icon({
    // iconUrl: '/assets/images/customMarker_red.png',
    iconUrl: '/assets/images/dark_green_square.png',
    iconSize: [25, 25],
    // iconAnchor: [0, 0],
});

export const red_recycle = L.icon({
    // iconUrl: '/assets/images/customMarker_red.png',
    iconUrl: '/assets/images/red_recycle.png',
    iconSize: [25, 25],
    // iconAnchor: [0, 0],
});

export const red_star = L.icon({
    // iconUrl: '/assets/images/customMarker_red.png',
    iconUrl: '/assets/images/red_star.png',
    iconSize: [25, 25],
    // iconAnchor: [0, 0],
});